import { render, staticRenderFns } from "./controlpanel.vue?vue&type=template&id=3a8814f7&"
import script from "./controlpanel.vue?vue&type=script&lang=js&"
export * from "./controlpanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports